import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"
import Colors from "../../Colors"

export const dashboardStyles = makeStyles((theme: Theme) => ({
  box1: {
    marginTop: "16px",
    marginLeft: "16px",
    marginRight: "16px",
  },

  hover_icons: {
    "&:hover": {
      color: "#fff",
    },
  },
  searchbar: {
    // width: "560px !important",
  },
  all: {
    background: "white",
    width: "13%",
    height: "30px",
    borderRadius: "5px",
    marginTop: "12px",
  },
  opd: {
    background: "white",
    width: "14%",
    height: "30px",
    borderRadius: "5px",
    marginTop: "12px",
  },
  downarrow: {
    width: "15%",
    paddingLeft: "10px",
  },
  welcomeText: {
    letterSpacing: "1px",
  },
  listWrapper: {
    marginTop: "65px !important",
  },
  patientSpacing: {
    marginRight: "16px",
    marginLeft: "16px",
  },
  pending: {
    marginTop: "10px",
    paddingRight: "10px",
  },
  warning: {
    width: "45px",
    padding: "2px",
  },
  patientSelectorHeader: {
    width: "100%",
    height: "67px",
    backgroundColor: Colors.greyselector,
    // background:"black",
    borderRadius: "5px",
  },
  marign20: {
    marginTop: "10px",
    marginLeft: "90px",
  },
  locationName: {
    padding: "5px",
  },
  location: {
    width: "21px",
    paddingLeft: "7px",
  },
  divideruser: {
    // paddingLeft: '4px',
    // marginTop: '12px',
    // paddingRight: '7px',

    marginLeft: "10px",
    marginRight: "10px",
  },
  holder: {
    paddingRight: "5px",
    paddingLeft: "5px",
  },
  dividers: {
    marginLeft: "10px",
    marginRight: "10px",
  },
  dividercall: {
    // marginTop: '12px',

    marginLeft: "10px",
    marginRight: "10px",
  },
  userName: {
    fontSize: "14px !important",
    fontWeight: "500 !important",
    textAlign: "right",
    lineHeight: "20px !important",
    color: "#1F2937"
  },
  userRole: {
    fontSize: "12px !important",
    fontWeight: "500 !important",
    textAlign: "right",
    lineHeight: "20px !important",
    color: "#6B7280"
  },
  mr2: {
    marginRight: "256px",
  },
  mt2: {
    marginTop: "16px",
  },
  addpatient: {
    width: "30px",
    padding: "2px",
  },
  addpatientbutton: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-evenly !important",
    height: "40px !important",
    backgroundColor: "#07A873 !important",
    boxShadow: "unset !important",
    padding: "8px 16px 8px 16px !important",
    gap: "8px"
  },
  buttonTitle: {
    fontSize: "14px !important",
    fontFamily: "Inter !important",
    letterSpacing: "1.5px !important",
    textTransform: "capitalize",
    fontWeight: "550 !important",
    lineHeight: "24px !important",
  },
  centerButtonTitle: {
    fontSize: "20px !important",
    fontFamily: "Inter !important",
    letterSpacing: "1.5px !important",
    textTransform: "capitalize",
    fontWeight: "400 !important",
    lineHeight: "27px !important",
    color: "#1F2937"
  },
  headersection: {
    boxShadow: "unset !important",
    borderBottom: "1px solid #DFE1E6",
    opacity: 1,
    backgroundColor: "white",
  },
  headerFlexSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "18px",
    '@media (max-width: 1024px)': {
      gap: "5px"
    }
  },
  modalNotification: {
    top: "10%",
    left: "52%",
    width: 400,
    background: "#251F4D",
    borderRadius: "8px",
    position: "absolute",
    overflow: "scroll",
  },
  marginNotification: {
    marginTop: "26px",
    marginBottom: "20px",
  },
  borderLine: {
    width: "25rem",
  },
  iconButtonNot: {
    marginLeft: "150px",
    marginTop: "25px",
  },
  marginl: {
    marginLeft: "22px",
  },
  modal_style: {
    top: "16%",
    left: "41%",
    width: "26%",
    background: Colors.blackGrey,
    padding: "20px",
    borderRadius: "16.1",
    position: "absolute",
    textAlign: "center",
  },
  doctorsvg: {
    height: "66%",
    marginTop: "5px",
  },
  justifyspacearound: {
    justifyContent: "space-around",
  },
  justifycontent: {
    justifyContent: "right",
  },
  content_Left: {
    justifyContent: "end",
  },
  textField: {
    marginBottom: "16px",
  },
  leftImage: {
    width: "100%",
    height: "100%",
  },
  logoImage: {
    height: "50px",
    cursor: "pointer",
  },
  mar: {
    marginLeft: "10px",
    marginRight: "10px",
  },
  opdHeader: {
    background: Colors.opdHeader,
  },

  m: {},
  signInOptions: {
    width: "229px",
    height: "37px",
    marginTop: "5px",
  },
  opdtext: {
    marginLeft: "7px",
  },

  input: {
    color: Colors.white,
  },
  borders: {},
  snackBar: {
    background: Colors.red,
    color: Colors.white,
  },
  bellSize: {
    height: "75px",
    width: "75px",
    // marginRight: '25px',
  },
  notificationSize: {
    height: "45px",
    width: "45px",
  },
  imageSize: {
    height: "40px",
    width: "40px",
    borderRadius: "8px",
  },
  accountSize: {
    padding: "2px",
    width: "50px",
    height: "20px",
    backgroundColor: Colors.blue1,
    borderRadius: "3px",
    textAlign: "center",
  },
  dropDownSize: {
    height: "14px",
    paddingTop: "0px",
    marginTop: "0px",
    paddingBottom: "0px",
    marginBottom: "0px",
  },
  errorMessages: {
    top: "440px",
    left: "867px",
    width: "191px",
    height: "15px",
    textAlign: "left",
    font: "normal normal 300 10px/16px Poppins",
    color: Colors.red,
    opacity: 1,
  },
  checkbox: {
    marginTop: "-9px",
  },
  buttons: {
    display: "flex",
    flexDirection: "row-reverse",
  },

  popoverfooter: {
    margin: " 0",
    padding: "8px 14px",
    backgroundColor: "#F7F7F7",
    borderBottom: "1px solid #EBEBEB",
    borderRadius: "5px 5px 0 0",
  },
  popovercontent: {
    overflowY: "scroll",
    height: "400px",
  },
  doctors: {
    width: "50%",
    height: "175px",
    background: "white",
    marginTop: "10px",
    borderRadius: "5px",
  },
  doctorsheader: {
    width: "100%",
    height: "46px",
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 2px 6px #8D9BB842",
  },
  bookAppointment: {
    // height:"100%",
    background: "#EDEEF4",
    borderRadius: "5px",
  },
  doctordividers: {
    padding: "5px",
  },
  approve: {
    paddingLeft: "2px",
  },
  flex: {
    display: "flex",
    justifyContent: "space-around",
  },
  hover_dashboard: {
    width: "16px",
    height: "8px",
    borderRadius: "8px",
    color: Colors.white,
    marginRight: "24px",
    marginLeft: "32px",
    borderColor: Colors.graphicsBg,
    background: "#282A42",
    opacity: 1,

    "&:hover": {
      borderColor: "#5047EA",
    },
    "&:disabled": {
      cursor: "not-allowed",
      pointerEvents: "unset!important",
    },
  },
  userImage: {
    width: "55px",
    height: "55px",
    textAlign: "center",
  },

  rightPaneMenuSection: {
    position: "absolute",
    right: "0",
    top: "0px",
    cursor: "pointer",
  },
  menuIcon: {
    width: "100px",
  },
}))
